export const Settings = {
    state: {},
    mutations: {},
    getters: {
        isSettingsActive(state, getters, rootState) {
            if (rootState.route.query.settings) {
                return true;
            }
            return false;
        },
        getSettingsPage(state, getters, rootState) {
            if (rootState.route.query.settings_page) {
                return rootState.route.query.settings_page;
            }
            return null;
        }
    },
    actions: {
        async openSettings(context, page = null) {
            let args = {
                settings: 1
            };
            if (page !== null) {
                args['settings_page'] = page;
            }
            await context.dispatch('routeAddQuery', args);
        },
        async closeSettings(context, page = null) {
            if (page === null) {
                await context.dispatch('routeRemoveQuery', [
                    'settings',
                    'settings_page',
                    'textpicker',
                    'textpicker_namespace'
                ]);
            } else if (page === '') {
                await context.dispatch('routeRemoveQuery', [
                    'settings_page',
                    'textpicker',
                    'textpicker_namespace'
                ]);
            } else {
                await context.dispatch('routeAddQuery', {
                    settings: 1,
                    settings_page: page
                });
            }
        }
    }
};
